const stickyObserver = new IntersectionObserver(
  ([e]) => e.target.toggleAttribute('data-stuck', e.intersectionRatio < 1),
  { threshold: [1] },
);

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sticky]').forEach(el => stickyObserver.observe(el));
});
